import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { BiEdit, BiShowAlt, BiHide } from "react-icons/bi";
import { AiOutlineCheck, AiOutlineClose, AiOutlineRight } from "react-icons/ai";
import { notifySuccess, notifyError } from "../../Services/Notifier";
import Util from "../../Classes/Util";
import { SlideService } from "./Services/SlideService";
import SlideModal from "./SlideModal";

const AllSlides = () => {
    const permissions = Util.decrypt(localStorage.getItem("Permissions"));

    const [searchText, setSearchText] = useState("");
    const [pendingSearch, setPendingSearch] = useState("");
    const [slides, setSlides] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [showModal, setShowModal] = useState(false);
    const [activeId, setActiveId] = useState(null);

    const loadSlides = async (pageNumber = page, size = pageSize, search = searchText) => {
        try {
            const result = await SlideService.getPaged(pageNumber, size, search);
            setSlides(result.Data);
            setTotalRows(result.Total);
            setPage(pageNumber);
            setPageSize(size);
        } catch {
            notifyError("Failed to load slides");
        }
    };


    const openAdd = () => {
        setActiveId(null);
        setShowModal(true);
    };

    const openEdit = (id) => {
        setActiveId(id);
        setShowModal(true);
    };

    const togglePublish = async (id) => {
        try {
            await SlideService.togglePublish(id);
            notifySuccess("Status updated");
            loadSlides();
        } catch {
            notifyError("Action failed");
        }
    };

    useEffect(() => {
        loadSlides();
    }, []);

    const columns = useMemo(
        () => [
            { name: "ID", selector: (r) => r.SlideId, sortable: true },
            { name: "Title", selector: (r) => r.Title, sortable: true },
            {
                name: "Published",
                cell: (r) => (r.IsPublished ? <AiOutlineCheck /> : <AiOutlineClose />),
                center: true,
            },
            {
                name: "Actions",
                cell: (r) => (
                    <div className="d-flex gap-2">
                        {permissions.ManageSlide && (
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => openEdit(r.SlideId)}
                            >
                                <BiEdit />
                            </button>
                        )}
                        {permissions.PublishSlide && (
                            <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => togglePublish(r.SlideId)}
                            >
                                {r.IsPublished ? <BiHide /> : <BiShowAlt />}
                            </button>
                        )}
                    </div>
                ),
            },
        ],
        [permissions]
    );

    return (
        <div className="rightSide">
            <div className="container-fluid mt-3">
                <h2>Slides</h2>
                <ul className="portalPath">
                    <li>
                        Home <AiOutlineRight />
                    </li>
                    <li>Slides</li>
                </ul>

                <div className="card">
                    <div className="card-body">

                    <div className="row mb-3 align-items-center">
                            {/* SEARCH */}
                            <div className="col-md-8">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search slides..."
                                        value={pendingSearch}
                                        onChange={(e) => setPendingSearch(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                setSearchText(pendingSearch);
                                                loadSlides(1, pageSize, pendingSearch);
                                            }
                                        }}
                                    />
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={() => {
                                            setSearchText(pendingSearch);
                                            loadSlides(1, pageSize, pendingSearch);
                                        }}
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>

                            {/* ADD BUTTON */}
                            <div className="col-md-4 text-end">
                                {permissions.ManageSlide && (
                                    <button className="btn btn-primary" onClick={openAdd}>
                                    + Add Slide
                                </button>
                                )}
                            </div>
                        </div>

                        <div className="portalTable">
                            <DataTable
                                columns={columns}
                                data={slides}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                paginationPerPage={pageSize}
                                onChangePage={(p) => loadSlides(p, pageSize)}
                                onChangeRowsPerPage={(newSize, p) => loadSlides(p, newSize)}
                                highlightOnHover
                                responsive
                            />
                        </div>

                    </div>
                </div>

                <SlideModal
                    show={showModal}
                    slideId={activeId}
                    onClose={() => setShowModal(false)}
                    onSaved={loadSlides}
                />

            </div>
        </div>
    );
};

export default AllSlides;
